// https://coolors.co/ffffff

export const theme = {
	colors: {
		primary: '#007FFF',
		powderWhite: '#FFFDF9',
		persianGreen: '#06B49A',
		lightBlue: '#AFDBD2',
		onyx: '#36313D',
		Capri: '#33B8F6',
		IndigoDye: '#113F5F',
		Cultured: '#F4F6F7',
		SpaceCadet: '#17224D',
		YellowGreen: '#50AC08',
		YellowOrange: '#ffb056',
		white: '#fff',
		black: '#000',
		Onyx: '#454545',
		BeauBlue: '#C6E2FF',
		Jet: '#303030',
		GreenPantone: '#10a744',
		SizzlingRed: '#F74356',
		DodgerBlue: '#3298FF',
		Bisque: '#FFE7CB',
		Nyanza: '#E7FFD3',
		AliceBlue: '#DEEEFF',
		CelticBlue: '#0168D0',
		Emerald: '#0BC173',
		YellowOrg: '#FEB24C',
		BattleShipGray: '#868686',
		Sliver: '#C6C6C6',
		TartOrange: '#FF4747',
		FuchsiaCrayola: '#D952D3',
		Platinum: '#E5E5E5',
		Maroon: '#6D2D49',
		LightGray: '#D7D7D7',
		LightBgGrey: '#ededed',
		ErrorMessage: '#f74356',
		NightRider: '#343434',
		GrayX: '#B6B6B6',
		LightSteelBlue: '#9DB7D1',
		GreenBg: '#FD6767',
		SilverChalice: '#AAAAAA',
		BgBlue: '#2D95FF',
		BgGrey: '#F3F1EF',
		CelBlue: '#006AD4',
		PurssianBlue: '#01376D',
		EerieBlack: '#1f1f1f',
		LavenderBlush: '#FFEFEF',
		Snow: '#FFF6F6',
	},
	fontSizes: {
		small: '1em',
		medium: '2em',
		large: '3em',
	},
};
